import React, { Component } from 'react';
import wx from 'weixin-js-sdk'
import './index.scss';
class bindingStudent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            telephone: '',
            ticket: '',
            correct: require('../../assets/wancheng.png'),
            userName: '',
            studentNo: '',
        }
    }
    componentDidMount() {
        const searchParams = new URLSearchParams(window.location.search)
        this.setState({
            telephone: searchParams.get('telephone'),
            ticket: searchParams.get('ticket')
        })
        if (searchParams.get('ticket')) {
            this.getDetail(searchParams.get('ticket'))
        }
        if (/Alipay/i.test(navigator.userAgent)) {
            const script = document.createElement('script');
            script.src = 'https://appx/web-view.min.js';
            document.head.appendChild(script);
        }
        window.document.title = '趣智后勤热水'
        console.log('telephone:', searchParams.get('telephone'));
        console.log('ticket:', searchParams.get('ticket'));
        // this.WxInit()
    }
    WxInit() {
        fetch('/api/wechat-signature')
            .then(res => res.json())
            .then(data => {
                wx.config({
                    debug: true,
                    appId: data.appId,
                    timestamp: data.timestamp,
                    nonceStr: data.nonceStr,
                    signature: data.signature,
                    jsApiList: ['launchMiniProgram']
                });
            });
    }
    getDetail = async (val) => {
        let devURl = {
            wenli: 'https://xc.klcxkj-qzxy.cn/combination/cas/wenli/validate',  //文理大学
            nongye: 'https://xc.klcxkj-qzxy.cn/combination/cas/nongye/validate', //河南农业大学
        }
        let url = `${devURl.wenli}?ticket=${val}`
        fetch(url).then(res => {
            return res.json()
        }).then(data => {
            console.log(data)
            this.setState({
                userName: data.data.userName,
                studentNo: data.data.studentNo
            })
        })
    }

    render() {
        const goWx = () => {
            const isWeChat = /MicroMessenger/i.test(navigator.userAgent);
            const isAlipay = /Alipay/i.test(navigator.userAgent);
            const { userName, studentNo } = this.state;
            const params = JSON.stringify({ userName, studentNo });
            const targetUrl = `/pages/index/index?info=${params}`;

            if (isWeChat) {
                wx.miniProgram.reLaunch({ url: targetUrl });
                return;
            }
            if (isAlipay) {
                if (window.my && window.my.reLaunch) {
                    window.my.reLaunch({ url: targetUrl });
                    return;
                }
                window.location.href = `alipays://platformapi/startapp?appId=2018090661238647&page=pages/index/index&query=info=${encodeURIComponent(params)}`;
                return;
            }
            alert('请在微信或支付宝中打开');
        }

        return (
            <>
                <div className='page-box'>
                    <div className='page-content'>
                        <div className='img-box'>
                            <div className='size-style'>学生信息</div>
                        </div>
                        <div className='detail-content'>
                            <div className='detail-box detail-active'>
                                <div>姓名：</div>
                                <div className='size-width'>{this.state.userName}</div>
                            </div>
                            <div className='detail-box'>
                                <div>学号：</div>
                                <div className='size-width'>{this.state.studentNo}</div>
                            </div>
                        </div>
                    </div>
                    <div className='btn-box'>
                        <div className='btn-con' onClick={goWx}>去绑定</div>
                    </div>
                </div>
            </>
        )
    }
}
export default bindingStudent;